import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default function (Alpine) {
  Alpine.store('swipers', {
    instances: {},

    registerSwiper(id, swiper) {
      this.instances[id] = {
        instance: swiper,
        activeIndex: swiper.activeIndex,
        isBeginning: swiper.isBeginning,
        isEnd: swiper.isEnd,
        slides: swiper.slides.length,
        progress: swiper.progress
      };
    },

    updateState(id, newState) {
      if (this.instances[id]) {
        Object.assign(this.instances[id], newState);
      }
    },

    getSwiperState(id) {
      return this.instances[id] || {};
    }
  });

  Alpine.directive('swiper', (el, { expression }, { evaluate, cleanup }) => {
    const swiperId = `swiper-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    el.dataset.swiperId = swiperId;

    const swiperOptions = expression ? (evaluate(expression) || {}) : {};
    const swiper = new Swiper(el, swiperOptions);

    Alpine.store('swipers').registerSwiper(swiperId, swiper);

    swiper.on('slideChange', () => {
      Alpine.store('swipers').updateState(swiperId, {
        activeIndex: swiper.activeIndex,
        isBeginning: swiper.isBeginning,
        isEnd: swiper.isEnd,
        progress: swiper.progress
      });
    });

    cleanup(() => {
      swiper?.destroy();
      delete Alpine.store('swipers').instances[swiperId];
    });
  });

  Alpine.directive('swiper-event', (el, { value, expression }, { evaluateLater, effect }) => {
    const camelCaseEvent = value.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
    const getHandler = evaluateLater(expression);

    effect(() => {
      const swiperEl = el.closest('[data-swiper-id]');
      const swiperId = swiperEl?.dataset.swiperId;

      if (!swiperId) {
        console.warn('swiper-event: No Swiper instance found.');
        return;
      }

      const swiper = Alpine.store('swipers').getSwiperState(swiperId).instance;
      if (!swiper) return;

      swiper.on(camelCaseEvent, () => {
        getHandler((callback) => {
          if (typeof callback === 'function') callback();
        });
      });
    });
  });

  Alpine.magic('swiper', (el) => {
    const swiperEl = el.closest('[data-swiper-id]');
    if (!swiperEl) return {};

    const swiperId = swiperEl.dataset.swiperId;

    return new Proxy({}, {
      get(target, prop) {
        const state = Alpine.store('swipers').getSwiperState(swiperId);
        const instance = state.instance;

        if (Object.hasOwn(state, prop)) return state[prop];

        if (instance && prop in instance) {
          return typeof instance[prop] === 'function'
            ? instance[prop].bind(instance)
            : instance[prop];
        }

        return undefined;
      }
    });
  });
}
